import { useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";

export const VariableDropdown = ({
  toggleDropdown,
  selectedVariableId,
  dropdownOpen,
  searchTerm,
  handleSearchChange,
  variables,
  handleChange,
  setDropdownOpen,
  headers,
}) => {
  const [selectedVariable, setSelectedVariable] = useState(null);

  return (
    <>
      <div className="qi-select_wrapper">
        <div className="qi-select">
          <div className="qi-select_text" onClick={toggleDropdown}>
            {selectedVariable ? selectedVariable?.display_name : "Select Variable"}
          </div>
          {dropdownOpen && (
            <div className="qi-select_dropdown">
              <input
                placeholder="Search..."
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                className="qi-select_search"
              />
              <ul className="qi-select_options">
                {variables?.data
                  ?.filter((data) =>
                    data?.display_name.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map((data, index) => (
                    <li
                      className="qi-select_option"
                      key={index}
                      onClick={() => {
                        handleChange("id", JSON.stringify(data));
                        setDropdownOpen(false);
                        setSelectedVariable(data);
                      }}
                    >
                      {data?.display_name} ({data?.section_name}
                      {data?.unit_name ? ` - ${data?.unit_name}` : ""})
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>
        <div className="text-red-600 small-error">{headers[0]?.error}</div>
      </div>
    </>
  );
};
